import { z } from 'zod';
import { optionalUuidString } from '../zod-helpers/index.js';
import { bomItemNameSchema, bomQuantityStringSchema } from './item-form.js';
// Part and type are set when an ingredient is added and can't be changed via updateBomItem
// (see update-bom-item.ts) — this form only ever edits name/quantity/uom.
export const bomItemEditFormSchema = z.object({
    name: bomItemNameSchema,
    quantity: bomQuantityStringSchema,
    uomId: optionalUuidString('Invalid UOM selection.'),
});
export function bomItemToEditFormState(item) {
    return {
        name: item.name,
        // toFixed(9) matches the Decimal(28,9) column's precision and avoids String()'s switch to
        // exponential notation below 1e-7 (e.g. String(0.000000001) === '1e-9').
        quantity: item.quantity.toFixed(9).replace(/\.?0+$/, ''),
        uomId: item.uom?.id ?? '',
    };
}
//# sourceMappingURL=update-item-form.js.map